import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  TextInput,
  ScrollView,
} from "react-native";
import Select from "react-select";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import { Feather } from "@expo/vector-icons";
import TableUser from "./tableuser";
import { apiservice } from "../../service/service";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { useRecoilState } from "recoil";
import { useIsFocused } from "@react-navigation/native";

const { width, height } = Dimensions.get("window");
export default function user({ navigation }) {
  const focus = useIsFocused();
  const [token, setToken] = useRecoilState(tokenState);
  const [data, setData] = useState([]);
  const [role, setrole] = useState(null);
  const [search, setsearch] = useState(null);
  const [statuses, setstatuses] = useState(null);

  async function getalluser() {
    const response = await apiservice({
      path: "/admin/get-admins",
      method: "get",
      token: token?.accessToken,
    });

    if (response.status == 200) {
      setData(response.data.data);
    }
  }
  const [items, setItems] = useState([
    { label: "member", value: "member" },
    { label: "VIP", value: "VIP" },
  ]);
  const [items1, setItems1] = useState([
    { label: "Active", value: "Active" },
    { label: "Block", value: "Block" },
  ]);

  useEffect(() => {
    getalluser();
  }, [focus]);

  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />

      <ScrollView>
        <View style={styles.back}>
          <Admin />

          <View style={styles.viewfree}>
            <Text style={styles.textfree}>Admins ({data.length})</Text>
            <TouchableOpacity
              onPress={() => navigation.navigate("CreateAdmin")}
              style={styles.touchadd}
            >
              <Text style={styles.textadd}>Add Admin</Text>
            </TouchableOpacity>
          </View>

          <TableUser
            navigation={navigation}
            data={data}
          />
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: "100%",
    height: height,
    paddingHorizontal: "1%",
  },
  viewfree: {
    justifyContent: "space-between",
    width: "100%",
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 24,
    color: "#172B4D",
    alignSelf: "center",
  },
  textfil: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#000",
  },
  textfilits: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#000",
  },
  viewfil: {
    width: "100%",
    backgroundColor: "#fff",
    height: 110,
    borderRadius: 10,
    marginTop: 10,
    padding: 10,
    zIndex: 999,
  },
});
